(async () => {
    const { Core } = await importModule('Core');
    
    customElements.define('express-option-list', class extends Core {

        elements = {
            toCartButton: 'product-to-cart',
            selectedVariantPrice: '[data-selected-variant-price]'
        }
        isSorted = false;
        render() {
            this.addEventListener('change', this._onSelect.bind(this))
        }

        _onSelect(e) {
            this.selectedVariantId = e.target.value;
            this.selectedVariantPrice = e.target.dataset.price;
            this.$toCartButton.variantId = this.selectedVariantId;

          try{
          this.$selectedVariantPrice.classList.remove("wpd-processed");
          // this.$selectedVariantPrice.setAttribute("data-wpd-variant-compare-at-price",e.compare_at_price == null?"":e.compare_at_price);
          this.$selectedVariantPrice.setAttribute("data-wpd-variant-price",e.target.dataset.wpdVariantPrice);
          this.$selectedVariantPrice.setAttribute("data-wpd-variant-id",this.selectedVariantId); 
          this.$selectedVariantPrice.setAttribute("data-wpd-product-handle", document.querySelector("[data-wpd-product-handle]").getAttribute("data-wpd-product-handle"));
            
          }catch(e){}
          
        }

        set selectedVariantPrice(value) {
            this.$selectedVariantPrice.innerText = value
        }
        
    })
})();